import React from 'react';

import PropTypes from 'prop-types';
import * as cn from 'classnames';

import * as c from './constants';

function Indicator({
  type,
  size,
  positionClassName,
  isAbsolute,
  className,
  withBorderWhite,
  children,
}) {
  const style = {
    size: c.SIZE_OPTS?.[size],
    background: c.TYPE_OPTS?.[type],
  };

  return (
    <div className={cn(isAbsolute && 'absolute', positionClassName)}>
      <div
        className={cn(
          'rounded-full flex items-center justify-center',
          style?.size,
          style.background,
          className,
          {
            'border border-primitive-white': withBorderWhite,
          }
        )}
      >
        {children && children}
      </div>
    </div>
  );
}

Indicator.defaultProps = {
  type: 'default',
  size: 'default',
  positionClassName: 'bottom-0 right-0',
  isAbsolute: false,
  withBorderWhite: false,
  className: '',
  children: false,
};

Indicator.propTypes = {
  size: PropTypes.oneOf(Object.keys(c.SIZE_OPTS)),
  withBorderWhite: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(c.TYPE_OPTS)),
  positionClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
  ]),
  isAbsolute: PropTypes.bool,
  className: PropTypes.string,
};

export default Indicator;
